import { Component } from "react"
import axios from "axios";
import { Row, Col, Typography, Modal, List, Space, Card, message } from 'antd';
import { renderEstatusVenta } from "../../../../Utils";

const { Text } = Typography

class ModalSelectAddress extends Component {

    constructor(props) {
        super(props);
        this.state = {
            orders: {
                data: [],
                limit: 11,
                page: 1,
                total: 0,
                pages: 0,
                filters: []
            },
            loading: false,
            address: {}
        };
    }

    get = async () => {

        axios.get('/direccion/' + this.props.direccion_id).then(({ data }) => {
            console.log("response", data);
            this.setState({
                address: data
            })
        })

        axios.get('/clientes/' + this.props.cliente_id).then(({ data }) => {
            console.log("response cliente", data);
            this.setState({
                client: data
            })
        })

        axios.get('/ventas', {
            params: {
                limit: 200,
                exclude_estatus: [5],
                pickup_and_deliver: true,
                cliente_id: this.props.cliente_id
            }
        }).then(({ data }) => {
            console.log("data", data);
            this.setState({
                orders: {
                    ...this.state.orders,
                    data: data.data,
                    total: data.total,
                    pages: data.pages
                }
            })
        })
    }

    componentDidMount() {
        this.get()
    }

    render() {
        return (
            <Row>
                <Col span={24}>
                    <List>
                        {/* Primer item fijo "None" */}
                        <List.Item key="none" className="w-100">
                            <Card hoverable className="w-100" onClick={async () => {
                                let clipboard =
                                    `${this.state.client.nombre_completo ?? ""} - 📞 ${this.state.client.telefono ?? ""}` +
                                    `\n 🚚 ${this.state.address.localizacion?.place_name ?? ""}` +
                                    `${this.state.address.especificaciones ? ` \n 🏢 ${this.state.address.especificaciones}` : ""}`;

                                await navigator.clipboard.writeText(clipboard)
                                message.success('Address copied to clipboard')
                                this.props.onClose()
                            }}>
                                <Row className="width-100" justify="space-between" size={5}>
                                    <Text>None</Text>
                                </Row>
                            </Card>
                        </List.Item>

                        {/* Items de orders */}
                        {this.state.orders.data.map(order => (
                            <List.Item key={order._id} className="w-100">
                                <Card hoverable className="w-100" onClick={async () => {
                                    let pairs = order.detalles
                                        .filter(item => item.servicio_id[0]?.tipo === 0)
                                        .reduce((acc, item) => acc + item.cantidad, 0)

                                    let clipboard =
                                        `${this.state.client.nombre_completo ?? ""} - 📞 ${this.state.client.telefono ?? ""}` +
                                        `\n 🚚 ${this.state.address.localizacion?.place_name ?? ""}` +
                                        `${this.state.address.especificaciones ? ` \n 🏢 ${this.state.address.especificaciones}` : ""}` +
                                        `${this.state.address.notas ? ` \n 📝 ${this.state.address.notas}` : ""}` +
                                        `\n 💵 ${order.total.toMoney(true)} USD  👟 ${pairs} Pairs`;

                                    await navigator.clipboard.writeText(clipboard)
                                    message.success('Address copied to clipboard')
                                    this.props.onClose()
                                }}>
                                    <Row className="width-100" justify="space-between" size={5}>
                                        <Text>{order.folio}</Text>
                                        <Text>{renderEstatusVenta(order.status)}</Text>
                                        <Text>
                                            {new Date(order?.createdAt).toLocaleString('en-US', {
                                                year: "numeric",
                                                month: "long",
                                                day: "numeric",
                                            }) ?? ""}
                                        </Text>
                                        <Text>$ {order.total.toMoney(true)} USD</Text>
                                    </Row>
                                </Card>
                            </List.Item>
                        ))}
                    </List>
                </Col>
            </Row>
        )
    }
}

export default function View(props) {

    const { visible = false, onClose = () => { } } = props

    return <Modal
        open={visible}
        onCancel={onClose}
        title={"Select an order to copy"}
        destroyOnClose={true}
        cancelText="Cancel"
        okText="Return"
    >
        <ModalSelectAddress {...props} />
    </Modal>

}